export const MENU_MATERIAL_ICONS = [
  "account_balance",
  "account_tree",
  "admin_panel_settings",
  "apps",
  "auto_awesome",
  "badge",
  "campaign",
  "category",
  "cloud",
  "cloud_upload",
  "dashboard",
  "database",
  "deployed_code",
  "devices",
  "dialpad",
  "event_busy",
  "fact_check",
  "flag",
  "forward_to_inbox",
  "handshake",
  "history",
  "image",
  "inventory_2",
  "key",
  "location_on",
  "language",
  "lock",
  "mail",
  "map",
  "mark_email_read",
  "memory",
  "package_2",
  "payments",
  "person",
  "groups",
  "picture_as_pdf",
  "policy",
  "public",
  "route",
  "rule",
  "sell",
  "send",
  "settings",
  "spa",
  "sync_alt",
  "table",
  "toggle_on",
  "travel_explore",
  "view_carousel",
  "vpn_key",
] as const;

export type MenuMaterialIcon = (typeof MENU_MATERIAL_ICONS)[number];

export type MenuIconValue = MenuMaterialIcon | "dot";

export type MenuIconKind = "material" | "dot" | "none";

export interface MenuIconDisplay {
  kind: MenuIconKind;
  value: string;
}

const MENU_MATERIAL_ICON_SET = new Set<string>(MENU_MATERIAL_ICONS);

const MENU_DOT_ICON: MenuIconDisplay = { kind: "dot", value: "dot" };
const MENU_NONE_ICON: MenuIconDisplay = { kind: "none", value: "" };

export function toMenuIconDisplay(icon: string | undefined): MenuIconDisplay {
  if (!icon) {
    return MENU_NONE_ICON;
  }

  if (icon === "dot") {
    return MENU_DOT_ICON;
  }

  if (MENU_MATERIAL_ICON_SET.has(icon)) {
    return { kind: "material", value: icon };
  }

  return MENU_DOT_ICON;
}
